const COMMON_PREFIX = "OFFER_TAG";

export const OFFER_TAG = {
    CONTAINER: `${COMMON_PREFIX}_CONTAINER`,
};
